import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { columnFilter } from '../../shared/misc-classes';

@Component({
  selector: 'column-filter-pop',
  templateUrl: './column-filter-pop.component.html',
  styleUrls: ['./column-filter-pop.component.css']
})
export class ColumnFilterPopComponent implements OnInit {

  @Input() colName:string;
  @Input() listItems:Array<columnFilter>;
  @Output() closeRequest:EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }


  itemClicked(_tmpItem:columnFilter){
    _tmpItem.isSelected = !_tmpItem.isSelected;
  }
  getSelectedCount():number{
    let counter = 0;
    if(this.listItems){
      this.listItems.forEach((_tmpItem:columnFilter) => {
        if(_tmpItem.isSelected == true){
          counter++;
        }
      });
    }
    
    return counter;
  }

  selectAll(){
    if(this.listItems){
      this.listItems.forEach((_tmpItem:columnFilter) => {
        _tmpItem.isSelected = true;
      });
    }
  }
  selectNone(){
    if(this.listItems){
      this.listItems.forEach((_tmpItem:columnFilter) => {
        _tmpItem.isSelected = false;
      });
    }
  }
  invertSelection(){
    if(this.listItems){
      this.listItems.forEach((_tmpItem:columnFilter) => {
        _tmpItem.isSelected = !_tmpItem.isSelected;
      });
    }
  }
  closePop(){
    this.closeRequest.emit();
  }

}
